import { CryptoUtils } from './crypto-utils.js';

const cryptoUtils = new CryptoUtils();

const FIELDS_TO_ENCRYPT = [
  "PK", "SK", "Description", "Address", "PartyName", 'DivisionCode', 'DivisionDescription',
  'BranchDescription', 'ActName', "CaseTitle", "CourtName", "CourtAddress", "OriginalDocuments",
  "BriefFacts", "AdvocateName", "DocumentsSubmitted", "DetailsHappenings", "RequirementsNextDate",
  "Verdict", "Analysis", "Remarks", "UploadedFileName", "NoticeInNameOf", "Details",
  "AgreementCode", "Type", "AddressOfProperty", "POAId", "NameOfAttorneyHolder",
  "Particulars", "DocumentExecuted", "Value", 'Status', "NoticeRefNo", 'Position',
  "NameOfAttorneyHolder", "LegislationName", "LawyerNameAddress",
  "ProductDescription", "AuthorityName", "DocumentsFiledWithRegistry", "Class", "IPRName", "RegistrationFileName"
];

export const encryptRequestData = async (data) => {
  if (!data || typeof data !== 'object') return data;

  const encryptedData = { ...data };

  // Encrypt specified fields
  for (const field of FIELDS_TO_ENCRYPT) {
    if (encryptedData[field]) {
      encryptedData[field] = await cryptoUtils.encrypt(encryptedData[field]);
    }
  }

  // Handle nested objects - skip lastEvaluatedKey
  for (const key in encryptedData) {
  
    if (key === 'lastEvaluatedKey') {
      // Skip encryption for lastEvaluatedKey as it contains DynamoDB pagination tokens
      continue;
    }
    if (typeof encryptedData[key] === 'object' && encryptedData[key] !== null) {
      if (encryptedData[key].PK) {
        encryptedData[key].PK = await cryptoUtils.encrypt(encryptedData[key].PK);
      }
      if (encryptedData[key].SK) {
        encryptedData[key].SK = await cryptoUtils.encrypt(encryptedData[key].SK);
      }
    }
  }

  return encryptedData;
};